import { render, staticRenderFns } from "./SearchIOS.vue?vue&type=template&id=0d4078d6&"
import script from "./SearchIOS.vue?vue&type=script&lang=js&"
export * from "./SearchIOS.vue?vue&type=script&lang=js&"
import style0 from "./SearchIOS.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports